import { useDispatch, useSelector } from 'react-redux';

import { WorkflowType } from 'modules/domains';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { RESET_TO_PUBLISHED_MODAL } from '../../../constants';
import { closeModal, getWorkflow, resetWorkflowDraftRequest } from '../../../ducks';

export const RESET_TO_PUBLISHED_BUTTON_TEST_ID = 'reset-to-published-button';

interface ResetToPublishedModalProps {
  /** Whether the modal is open */
  isOpen: boolean;
}

export const ResetToPublishedModal = ({ isOpen }: ResetToPublishedModalProps) => {
  const dispatch = useDispatch();
  const workflow = useSelector(getWorkflow);

  const handleCloseModal = () => dispatch(closeModal(RESET_TO_PUBLISHED_MODAL));

  const handleResetDraft = () => {
    const { workflowReference } = workflow;
    dispatch(
      resetWorkflowDraftRequest(
        Number(workflowReference?.id),
        workflowReference?.workflowType as WorkflowType,
      ),
    );

    handleCloseModal();
  };

  return (
    <Modal
      id={RESET_TO_PUBLISHED_MODAL}
      isModalOpen={isOpen}
      onClose={handleCloseModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>Reset draft?</ModalHeader>
      <ModalBody>
        <p>
          This will discard your changes and revert the draft to the published version of the
          journey.
        </p>
      </ModalBody>
      <ModalFooter>
        <PrimaryButton
          data-test={RESET_TO_PUBLISHED_BUTTON_TEST_ID}
          onClick={handleResetDraft}
          size={BUTTON_SIZES.LARGE}
        >
          Reset draft
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
